import {
  SALESPROMO_LOADING,
  GET_SALESPROMO,
  GET_SALESPROMO_SUCCESS,
  GET_SALESPROMO_FAIL,
  ADD_SALESPROMO_SUCCESS,
  ADD_SALESPROMO_FAIL,
  DELETE_SALESPROMO_SUCCESS,
  DELETE_SALESPROMO_FAIL,
  UPDATE_SALESPROMO_SUCCESS,
  UPDATE_SALESPROMO_FAIL,
  SALESPROMO_RESET
} from "./actionType";

const INIT_STATE = {
  salesPromos: [],
  error: {},
};

const SalesPromo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESPROMO_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESPROMO:
          return {
            ...state,
            salesPromos: action.payload.data,
            isSalesPromoCreated: false,
            isSalesPromoSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESPROMO_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESPROMO_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesPromoCreated: false,
            isSalesPromoSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESPROMO: {
      return {
        ...state,
        isSalesPromoCreated: false,
        loading: true,
      };
    }

    case SALESPROMO_LOADING: {
      return {
        ...state,
        isSalesPromoCreated: false,
        loading: true,
      };
    }

    case ADD_SALESPROMO_SUCCESS:
      return {
        ...state,
        isSalesPromoCreated: true,
        loading: false,
        salesPromos: [action.payload.data, ...state.salesPromos],
      };

    case ADD_SALESPROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESPROMO_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesPromoCreated: true,
        salesPromos: state.salesPromos.filter(
          salesPromo => salesPromo.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESPROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESPROMO_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesPromoCreated: true,
        salesPromos: state.salesPromos.map(salesPromo =>
          salesPromo.id.toString() === action.payload.data.id.toString() ? { ...salesPromo, ...action.payload.data } : salesPromo
        ),
      };

    case UPDATE_SALESPROMO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESPROMO_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesPromo;